import * as signalR from '@microsoft/signalr';

const getHubUrl = () => {
  const apiUrl = (import.meta.env.VITE_API_BASE_URL || '').replace(/\/$/, '');
  return `${apiUrl}/hubs/chat`;
};

const joinConversation = async (connection, config) => {
  if (config.audience === 'customer') {
    const method = config.subjectType === 'booking'
      ? 'JoinBookingChat'
      : 'JoinBookingRequestChat';
    await connection.invoke(method, config.referenceCode, config.chatAccessToken);
    return;
  }

  const method = config.subjectType === 'booking'
    ? 'JoinCompanyBookingChat'
    : 'JoinCompanyBookingRequestChat';
  await connection.invoke(method, config.subjectId);
};

export const connectToChat = async (config, onMessage) => {
  const connectionOptions = config.audience === 'staff'
    ? {
        accessTokenFactory: () => localStorage.getItem('accessToken') || '',
        withCredentials: true,
      }
    : { withCredentials: true };

  const connection = new signalR.HubConnectionBuilder()
    .withUrl(getHubUrl(), connectionOptions)
    .withAutomaticReconnect()
    .build();

  connection.on('ChatMessageCreated', (payload) => {
    const message = payload?.message ?? payload?.Message ?? payload;
    if (message) onMessage(message);
  });

  connection.onreconnected(() => {
    joinConversation(connection, config).catch(() => {});
  });

  try {
    await connection.start();
    await joinConversation(connection, config);
    return connection;
  } catch (error) {
    await connection.stop().catch(() => {});
    throw error;
  }
};
